/** Days remaining until `isoDate`, rounded up. Null when the date is missing. */
export const trialDaysLeft = (isoDate) => {
	if (!isoDate) {
		return null;
	}
	const ms = new Date(isoDate).getTime() - Date.now();
	if (Number.isNaN(ms)) {
		return null;
	}
	return Math.max(0, Math.ceil(ms / 86400000));
};

export const trialDaysLeftLabel = (days) => {
	if (days == null) {
		return '';
	}
	return days === 1 ? '1 day left' : `${days} days left`;
};

let choosePlanOpener = null;

export const registerChoosePlanOpener = (open) => {
	choosePlanOpener = open;
	return () => {
		if (choosePlanOpener === open) {
			choosePlanOpener = null;
		}
	};
};

export const openChoosePlan = () => {
	choosePlanOpener?.();
};
